import { css } from "styled-components";

export default css`
  *,
  a:active,
  a:hover {
    outline: 1px solid transparent;
  }

  fieldset:not([id^="dhl-input-group-"]) {
    border: 0;
    margin: 0;
    padding: 0;
  }

  dhl-button[is-disabled],
  dhl-button[is-disabled="false"] {
    pointer-events: auto !important;
  }

  dhl-button[is-disabled="true"] {
    pointer-events: none !important;
  }

  dhl-input-field .dhl-validation-feedback-icon--only,
  [dir="ltr"] dhl-input-field .dhl-validation-feedback-icon--only {
    right: var(--dui-size-space-5x) !important;
  }

  [dir="rtl"] dhl-input-field .dhl-validation-feedback-icon--only {
    left: var(--dui-size-space-5x) !important;
    right: unset !important;
  }

  dhl-input-field {
    & > div > input {
      height: 54px !important;
    }
    & > div label {
      font-size: var(--dui-size-font-xs) !important;
      color: var(--dui-color-black-400) !important;
    }

    & > div > input.is-valid {
      // Temporary fix until variable is available on larger scope
      padding-right: calc(
        var(--dui-size-space-6x) + calc(var(--dui-size-theme) * 1.313rem)
      ) !important;
    }

    & > div > input:focus {
      appearance: none;
    }
  }

  [dir="rtl"] dhl-input-field {
    & > div > input.is-valid {
      // Temporary fix until variable is available on larger scope
      padding-left: calc(
        var(--dui-size-space-6x) + calc(var(--dui-size-theme) * 1.313rem)
      ) !important;
    }
  }

  dhl-dropdown {
    & > div > div label {
      font-size: var(--dui-size-font-xs) !important;
      color: var(--dui-color-black-400) !important;
    }
    .content-container,
    .content-wrapper {
      height: 54px !important;
    }

    dhl-placeholder span {
      top: var(--dui-size-space-2x) !important;
    }

    .dropdown-container .options-container[data-popper-placement="bottom"] {
      transform: translate3d(
        0,
        calc(var(--dui-size-theme) * 3.25rem),
        0
      ) !important;
    }
  }

  dhl-panel > div:not(.button-only-trigger) > div,
  dhl-panel > div:not(.button-only-trigger) > div[style] {
    height: 0;
    margin: 0;
    opacity: 0;
    overflow: hidden;
    position: relative;
    transform: scaleY(0);
    transform-origin: top;
    transition: transform cubic-bezier(0.4, 0.18, 0.41, 0.87) 200ms; // Copied from DUIL v13.0.0
    will-change: transform;
    display: block !important; // To override the display: none of style attribute
  }

  dhl-panel > div:not(.button-only-trigger) > div:not([hidden]) {
    cursor: initial !important;
    border-bottom: 0;
    border-top: 0;
    height: auto;
    opacity: 1;
    overflow: visible;
    transform: scaleY(1);
  }
`;
